// File type icons and labels
const FILE_TYPES = {
  // Documents
  pdf: { icon: '📄', label: 'PDF', color: '#E53935' },
  doc: { icon: '📝', label: 'DOC', color: '#1976D2' },
  docx: { icon: '📝', label: 'DOCX', color: '#1976D2' },
  txt: { icon: '📃', label: 'TXT', color: '#757575' },
  rtf: { icon: '📃', label: 'RTF', color: '#757575' },
  odt: { icon: '📝', label: 'ODT', color: '#43A047' },

  // Spreadsheets
  xls: { icon: '📊', label: 'XLS', color: '#43A047' },
  xlsx: { icon: '📊', label: 'XLSX', color: '#43A047' },
  csv: { icon: '📊', label: 'CSV', color: '#43A047' },

  // Presentations
  ppt: { icon: '📽️', label: 'PPT', color: '#E65100' },
  pptx: { icon: '📽️', label: 'PPTX', color: '#E65100' },

  // Images
  jpg: { icon: '🖼️', label: 'JPG', color: '#8E24AA' },
  jpeg: { icon: '🖼️', label: 'JPEG', color: '#8E24AA' },
  png: { icon: '🖼️', label: 'PNG', color: '#8E24AA' },
  gif: { icon: '🖼️', label: 'GIF', color: '#8E24AA' },
  webp: { icon: '🖼️', label: 'WEBP', color: '#8E24AA' },
  svg: { icon: '🖼️', label: 'SVG', color: '#8E24AA' },
  bmp: { icon: '🖼️', label: 'BMP', color: '#8E24AA' },

  // Audio
  mp3: { icon: '🎵', label: 'MP3', color: '#00897B' },
  wav: { icon: '🎵', label: 'WAV', color: '#00897B' },
  ogg: { icon: '🎵', label: 'OGG', color: '#00897B' },
  flac: { icon: '🎵', label: 'FLAC', color: '#00897B' },
  m4a: { icon: '🎵', label: 'M4A', color: '#00897B' },

  // Video
  mp4: { icon: '🎬', label: 'MP4', color: '#D32F2F' },
  mov: { icon: '🎬', label: 'MOV', color: '#D32F2F' },
  avi: { icon: '🎬', label: 'AVI', color: '#D32F2F' },
  mkv: { icon: '🎬', label: 'MKV', color: '#D32F2F' },
  webm: { icon: '🎬', label: 'WEBM', color: '#D32F2F' },

  // Archives
  zip: { icon: '📦', label: 'ZIP', color: '#FFA000' },
  rar: { icon: '📦', label: 'RAR', color: '#FFA000' },
  '7z': { icon: '📦', label: '7Z', color: '#FFA000' },
  tar: { icon: '📦', label: 'TAR', color: '#FFA000' },
  gz: { icon: '📦', label: 'GZ', color: '#FFA000' },

  // Code/Data
  json: { icon: '{ }', label: 'JSON', color: '#FFB300' },
  xml: { icon: '< >', label: 'XML', color: '#FF7043' },
  html: { icon: '< >', label: 'HTML', color: '#E65100' },
  css: { icon: '🎨', label: 'CSS', color: '#2196F3' },
  js: { icon: '⚡', label: 'JS', color: '#FDD835' },

  // Default
  default: { icon: '📎', label: 'FILE', color: '#9E9E9E' },
}

/**
 * Get file extension from URL or filename
 */
export function getFileExtension(url) {
  if (!url) return ''
  const match = url.match(/\.([a-zA-Z0-9]+)(?:\?|$)/)
  return match ? match[1].toLowerCase() : ''
}

/**
 * Get file type info (icon, label, color) for a given URL or extension
 */
export function getFileTypeInfo(url) {
  const ext = typeof url === 'string' && url.includes('.')
    ? getFileExtension(url)
    : url?.toLowerCase() || ''

  return FILE_TYPES[ext] || FILE_TYPES.default
}

/**
 * Get just the icon for a file type
 */
export function getFileIcon(url) {
  return getFileTypeInfo(url).icon
}

/**
 * Get just the label for a file type
 */
export function getFileLabel(url) {
  const ext = getFileExtension(url)
  return ext ? ext.toUpperCase() : 'FILE'
}
